import { useSelector } from 'react-redux';
import { FilterState } from '../reducers/filterReducer';

export const useFilterSelector = (): FilterState =>
    useSelector((state: any) => state.filter);
